import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { pathOr } from 'ramda';
import { Select } from 'ui/styled';
import { useCareChoicesQuery } from 'apollo/queries/CARE_CHOICES';
var CareChoiceSelect = function (_a) {
    var _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.value, value = _d === void 0 ? [] : _d, _e = _a.dataTest, dataTest = _e === void 0 ? 'careChoiceSelectDropdown' : _e, choiceType = _a.choiceType;
    var _f = useCareChoicesQuery(), data = _f.data, loading = _f.loading;
    var careChoices = pathOr([], ['care_choices', 'nodes'], data);
    var filteredCareChoises = careChoices.filter(function (i) { return i === null || i === void 0 ? void 0 : i[choiceType]; });
    var options = filteredCareChoises.map(function (_a) {
        var id = _a.id, name = _a.name;
        return ({
            value: id,
            label: name
        });
    });
    return (_jsx(Select, { placeholder: "Select care choice", mode: "multiple", disabled: disabled, onChange: onChange, value: value, options: options, loading: loading, "data-test": dataTest }));
};
export default CareChoiceSelect;
